export default __webpack_public_path__ + "static/media/10.da20d572.jpg";